import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { useParams, useHistory } from 'react-router-dom';
import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Paper,
  Card,
  CardContent,
  Typography,
  Button,
  Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Modal from '@mui/material/Modal';
import ReportRequestScreen_2 from '../ReportRequestScreen/ReportRequestScreen_2';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  forCard: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  noColumn: {
    borderRight: '1px solid black',
    cursor: 'pointer'
  },
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    backgroundColor: 'white',
    padding: theme.spacing(4),
    boxShadow: theme.shadows[5],
    borderRadius: '8px'
  }
}));

function ReportRequestScreen() {
  const classes = useStyles();
  const [reportData, setReportData] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedKulKodu, setSelectedKulKodu] = useState([]);

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = (sortField = '') => {
    axios
      .get('/GetReports')
      .then(response => {
        let data = response.data;
        if (sortField) {
          data = data.sort((a, b) => {
            if (a[sortField] < b[sortField]) return -1;
            if (a[sortField] > b[sortField]) return 1;
            return 0;
          });
        }
        setReportData(data);
      })
      .catch(error => {
        // Hata yönetimi
      });
  };

  const handleSort = field => {
    setOrderBy(field);
    handleSearch(field);
  };

  const handleOpen = row => {
    setSelectedRow(row.RAPOR_KODU);
    setSelectedKulKodu(row.ACIKLAMA);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Card className={classes.forCard}>
        <CardContent>
          <Grid item xs={12} sm={12} md={12}>
            <TableContainer component={Paper}>
              <Table size="medium">
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        border: '1px solid #ddd',
                        color: '#fff',
                        backgroundColor: '#0033a0',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleSort('RAPOR_KODU')}
                    >
                      No
                    </TableCell>
                    <TableCell
                      style={{
                        border: '1px solid #ddd',
                        color: '#fff',
                        backgroundColor: '#0033a0',
                        cursor: 'pointer'
                      }}
                      align="center"
                      onClick={() => handleSort('ACIKLAMA')}
                    >
                      Açıklama
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData?.map(row => (
                    <TableRow hover key={row.ID}>
                      <TableCell
                        className={classes.noColumn}
                        onClick={() => handleOpen(row)}
                      >
                        {row.RAPOR_KODU}
                      </TableCell>
                      <TableCell align="center">{row.ACIKLAMA}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </CardContent>
      </Card>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalContent}>
          <ReportRequestScreen_2
            reportNo={selectedRow}
            kulRapor={selectedKulKodu}
          />
          <Button onClick={handleClose} variant="contained" color="warning">
            Kapat
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default ReportRequestScreen;
